import React from 'react';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import './styles.css';

const UploadWindow = ({
  files,
  onMinimize,
  minimized,
  onCancel,
  onFileCancel, // per-file cancel
}) => {
  return (
    <div className={`upload-window card-bg ${minimized ? 'minimized' : ''}`}>
      <div className="upload-header">
        <h6 className="mb-0">File Upload</h6>
        <div className="d-flex">
          <Button
            onClick={onMinimize}
            icon={minimized ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
            className="p-button-rounded p-button-text p-button-sm"
          />
          <Button onClick={onCancel} icon={'pi pi-times'} className="p-button-rounded p-button-text p-button-sm" />
        </div>
      </div>
      {!minimized && (
        <div className="upload-body thin-scrollbar">
          {Object.keys(files)
            .filter((key) => {
              const file = files[key];
              return file?.file && (!file?.completed || file?.error);
            })
            .map((key) => {
              const file = files[key];
              if (!file?.file) return null;
              return (
                <div key={key} className="upload-item">
                  <div className="file-info">
                    <p className="file-name">{file.file.name}</p>
                    {!file?.error && (
                      <Button
                        icon="pi pi-times"
                        className="p-button-rounded p-button-text p-button-sm"
                        onClick={() => onFileCancel && onFileCancel(key)}
                        aria-label={`Cancel ${file.file.name}`}
                      />
                    )}
                  </div>
                  {file?.error ? (
                    <div className="d-flex align-items-center gap-1 mt-1">
                      <i className="pi pi-exclamation-circle" style={{ color: '#e24c4c', fontSize: '0.85rem' }} />
                      <span style={{ color: '#e24c4c', fontSize: '0.8rem' }}>Upload failed</span>
                    </div>
                  ) : (
                    <ProgressBar
                      color="#4BA256"
                      value={file.progress}
                      style={{ height: 12, lineHight: '0.8rem' }}
                      displayValueTemplate={() => <>{!file?.paused ? file.progress + '%' : file.completed ? 'Completed' : 'Paused'} </>}
                    />
                  )}
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default UploadWindow;
